import React, { useState, useEffect, useRef } from 'react';
import '../styles/TravelPageNav.css'; // Adjust the path if needed

const TravelPageNav = () => {
  const [activeSection, setActiveSection] = useState('overview');

  const sectionRefs = {
    overview: useRef(null),
    myot: useRef(null),
    itinerary: useRef(null),
    inclusionExclusion: useRef(null),
    dayWisePlan: useRef(null),
    privacyandterms: useRef(null),
  };

  const navItems = [
    { id: 'overview', label: 'Overview' },
    { id: 'itinerary', label: 'Itinerary' },
    { id: 'inclusionExclusion', label: 'Inclusion & Exclusion' },
    { id: 'dayWisePlan', label: 'Day-Wise Plan' },
    { id: 'privacyandterms', label: 'TnC' },
  ];

  const scrollToSection = (sectionId) => {
    const section = sectionRefs[sectionId].current;
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setActiveSection(sectionId);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPosition = window.scrollY;

      for (const sectionId in sectionRefs) {
        const section = sectionRefs[sectionId].current;
        if (
          section &&
          section.offsetTop <= currentScrollPosition + 100 &&
          section.offsetTop + section.offsetHeight > currentScrollPosition
        ) {
          setActiveSection(sectionId);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    navItems.forEach((item) => {
      sectionRefs[item.id].current = document.getElementById(item.id);
    });
  }, [navItems]);

  return (
    <div className="travel-page-nav" style={{ margin: '20px' }}>
      <nav className="nav">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => scrollToSection(item.id)}
            className={`nav-item ${activeSection === item.id ? 'active' : ''}`}
          >
            {item.label}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default TravelPageNav;
